<div class="breadcrumb-area">
	<h1>Bodegas</h1>
</div>
<div class="card mb-5">
	<div class="card-header">
		<h3>Administración de Bodegas<a (click)="creating = true" *ngIf="!creating"><i
					class="a-hover fa fa-plus"></i></a></h3>
	</div>
	<div class="card-body">
		<p class="text-muted">Una bodega se encuentra activa si el icono <i class="fa fa-power-off"></i> se encuentra
			en color <span style="font-weight: 900;color: green;">verde</span>. Activa o desactiva la bodega dando
			click sobre el icono antes mencionado.</p>
		<div class="input-group input-group-sm mb-3">
			<label for="filterWarehouse" class="input-group-text">Filtra</label>
			<input type="text" (input)="filter()" [(ngModel)]="filterWord" name="filterWarehouse"
				placeholder="Ingresa el código o el nombre de la bodega" id="filterWarehouse" class="form-control">
		</div>
		<div class="row">
			<div class="col-sm">
				<div class="table table-responsive" *ngIf="filterWarehouses.length>0">
					<table class="table table-hover table-responsive">
						<caption *ngIf="filterWord">Se muestran los resultados para {{filterWord}}</caption>
						<thead>
							<tr>
								<th class="ta">
									Estado
								</th>
								<th class="ta">
									Código
								</th>
								<th>
									Nombre
								</th>
								<th class="ta">
									Encargado
								</th>
								<th class="ta">
									Tipo
								</th>
								<th>
									Ubicación
								</th>
								<th class="ta">
									Editar
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let warehouse of filterWarehouses">
								<tr>
									<td class="ta">
										<i (click)="activeOrInactive(warehouse)" class="status-category fa fa-power-off"
											[class.active-category]="warehouse.active"></i>
									</td>
									<td class="ta">
										{{warehouse.code}}
									</td>
									<td>
										{{warehouse.name}}
									</td>
									<td class="ta">
										<span *ngIf="warehouse.manager">
											{{warehouse.manager}}
										</span>
										<span *ngIf="!warehouse.manager" class="opacity-30">
											<i class="fa fa-circle-info"></i> Desconocido.
										</span>
									</td>
									<td class="ta">
										{{getCategoryName(warehouse.storeCategory)}}
									</td>
									<td>
										<span *ngIf="warehouse.location">
											{{warehouse.manager}}
										</span>
										<span *ngIf="!warehouse.location" class="opacity-30">
											<i class="fa fa-circle-info"></i> No disponible
										</span>
									</td>
									<td class="ta">
										<span class="a-hover" (click)="editWarehouse(warehouse)"><i
												class="fa fa-edit"></i></span>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
				<span *ngIf="filterWarehouses.length==0">
					<i class="fa fa-circle-info"></i>
					{{filterWord?'No existen bodegas para el filtro '+filterWord:'Aún no se han ingresado bodegas'}}
				</span>
			</div>
		</div>
	</div>
</div>
<app-modal-create-warehouse *ngIf="creating" (close)="closeCreate($event)"></app-modal-create-warehouse>
<app-modal-edit-warehouse *ngIf="editing" [newWarehouse]="edit" [warehouseId]="warehouseEdit" (close)="closeEdit($event)"></app-modal-edit-warehouse>